exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active[data-v-baf1f508]{background-color:#e0e0e0}.dropdown-search-result-wrapper[data-v-baf1f508]{max-height:200px;overflow-y:auto}", ""]);

// exports
